import React, { } from "react";
import styles from "./style.module.scss";
import ConditionalInputGroup from "../ConditionalInputGroup";
import cx from "classnames";
import { Input, InputGroupText } from "reactstrap";
import { CurrencyDollar } from 'react-bootstrap-icons';

const DefaultInput = (props) => {
  const { className, inputProps, onChange, onBlur, value,
    isDisabled, id, type, inputType, checkedValue,
    unCheckedValue, suffix, onTableInput = false, inputErrors = false } = props;

  const triggerOnChange = (e) => {
    if (onChange) {
      let event = e;

      if (isCheckboxInput() && checkedValue != null && unCheckedValue != null) {
        event.checkedValue = checkedValue;
        event.unCheckedValue = unCheckedValue;
      }
      onChange(event);
    }
  }

  const isCheckboxInput = () => {
    return type === "checkbox";
  }

  const getInputSuffix = (inputType) => {
    let inputGroupContent;

    if (inputType === "money") {
      inputGroupContent = (
        <CurrencyDollar size="1rem" />
      );
    } else if (suffix) {
      inputGroupContent = suffix;
    }

    return (
      inputGroupContent && (
        <InputGroupText className={cx(
          {
            [styles.suffixInputOnTableSpan]: onTableInput
          }
        )}>
          {inputGroupContent}
        </InputGroupText>
      )
    );

  }

  return (
    <ConditionalInputGroup condition={!isCheckboxInput()}>
      <Input
        {...inputProps}
        checked={isCheckboxInput() && value}
        disabled={isDisabled}
        value={value}
        type={type}
        id={id}
        className={cx(
          {
            [styles.suffixInput]: inputType === "money" || suffix,
            [styles.suffixInputOnTable]: onTableInput,
            className: className
          }
        )}
        onBlur={onBlur}
        onChange={(e) => triggerOnChange(e)} >
      </Input>
      {getInputSuffix(inputType)}
      {inputErrors}
    </ConditionalInputGroup>
  );
}

export default DefaultInput;